var MessageService = (function () {
    function MessageService() {
        this.messages = [];
    }
    MessageService.prototype.add = function (message) {
        this.messages.push(message);
    };
    MessageService.prototype.clear = function () {
        this.messages.length = 0;
    };
    return MessageService;
}());
export { MessageService };



// WEBPACK FOOTER //
// ./src/app/message.service.ts.pre-build-optimizer.js